import {lazy} from 'react';
import getIsContactNumberInInvalidFormatForOptty
from '../../../v2/selectors/PaymentOptionSelectors/Optty/getIsContactNumberInInvalidFormatForOptty';
import makeGetDoesOpttySubTypeRequireGenericBillingAddress
from '../../../v2/selectors/PaymentOptionSelectors/Optty/makeGetDoesOpttySubTypeRequireGenericBillingAddress';
import {getOrderTotal} from '../../../v2/selectors/selectors';
import MessageType from '../../../enums/MessageType';
import getOpttyPaymentOptionMessage from './getOpttyPaymentOptionMessage';

const LazyGenericBillingAddressPaymentOptionContents = lazy(() => import('./Optty/GenericBillingAddressPaymentOptionContents' /* webpackChunkName: 'GenericBillingAddressPaymentOptionContents' */));

export const getOpttyPaymentOptionAttributes = (paymentOption, state) => {
  const {
    imageUrl, type, component, minAmount, maxAmount,
  } = paymentOption;
  const opttyPaymentOptionId = component?._id || type;
  const contents = makeGetDoesOpttySubTypeRequireGenericBillingAddress(type)(state)
    ? LazyGenericBillingAddressPaymentOptionContents
    : null;
  
  const orderTotal = getOrderTotal(state);
  const isBelowMinimum = minAmount && orderTotal < minAmount;
  const isAboveMaximum = maxAmount && orderTotal > maxAmount;
  
  return {
    inputId: `OPTTY--${opttyPaymentOptionId}`,
    paymentName: `checkout.payment.method.optty.${type}.name`,
    icons: {url: imageUrl},
    alwaysShowTitle: true,
    useFullSizeIconsInArray: true,
    paymentOptionContents: contents,
    getMessage: () => {
      if (isBelowMinimum) {
        return {
          type: MessageType.ERROR,
          translationKey: 'checkout.payment.method.optty.minimum.amount.error',
          embeddedValues: [minAmount],
        };
      }
      
      if (isAboveMaximum) {
        return {
          type: MessageType.ERROR,
          translationKey: 'checkout.payment.method.optty.maximum.amount.error',
          embeddedValues: [maxAmount],
        };
      }
      
      if (getIsContactNumberInInvalidFormatForOptty(state)) {
        return {
          type: MessageType.ERROR,
          translationKey: 'checkout.payment.method.optty.contact.number.error',
          embeddedValues: [],
        };
      }
      
      return getOpttyPaymentOptionMessage(type);
    },
    getShouldHide: () => false,
    getIsDisabled: () => isBelowMinimum || isAboveMaximum || !!getIsContactNumberInInvalidFormatForOptty(state, true),
  };
};

export default getOpttyPaymentOptionAttributes;
